module.exports = __webpack_public_path__ + "img/9.6c45f0b3.jpg";